module.exports = __webpack_public_path__ + "static/media/gryphon_musee_hero_currentexhibition_3.a6ccb17a.jpg";